import { useMutation } from '@tanstack/react-query'
import { downloadInvoicePdf } from 'api/admin/charges/downloadInvoicePdf'

export function useDownloadInvoicePdfMutation() {
  return useMutation({
    mutationFn: (invoiceId: number) => downloadInvoicePdf(invoiceId),
  })
}
